module.exports = __webpack_public_path__ + "img/img_size2_jf.31ca7358.png";